(() => {
  clickTracking.$inject = ["Tracking"];

  function clickTracking(Tracking) {
    'ngInject';
    /*
    PLEASE READ THIS BEFORE IMPLEMENTING CLICK TRACKING ON CLINIC
     HOW TO ADD CLICK TRACKING TO EXISTING BUTTONS OR URL LINKS
     FOR BUTTONS:
      <button> </button>   =>   <button click-tracking="[ <screen or section>, <button label>, <optional detail 1>.....<optional detail n> ]"> </button>
       EXAMPLES:
      <button> </button>   =>   <button click-tracking="[ 'Questionnaire', 'Continue', 'Question #' + vm.formId ]"> </button>
                                <button click-tracking="[ 'Preflight', 'Zip Code / Next' ]"> </button>
      FOR URL LINKS - IF LINK IS INSIDE CLINIC:
      <a> </a>   =>   <a click-tracking="[ <screen or section>, <link text display>, <optional detail 1>.....<optional detail n> ]"> </a>
       EXAMPLE:
      <a> </a>   =>   <a click-tracking="[ 'Questionnaire', 'Continue', 'Question #' + vm.formId ]"> </a>
      FOR URL LINKS - IF LINK IS OUTSIDE CLINIC (LINK TO EXTERNAL SITE OR BROCHURE PAGE):
      <a> </a>   =>   <a target="_blank" click-tracking="[ <screen or section>, <link text display>, <optional detail 1>.....<optional detail n> ]"> </a>
       WE NEED TO ADD (IF MISSING) target="_blank" TO OPEN IN A NEW BROWSER TAB BECAUSE
      IF WE OPEN AN EXTERNAL SITE LINK OR A BROCHURE PAGE LIKE IN THE SAME BROWSER TAB
      ==>> CLICK TRACKING WILL FAIL BECAUSE TRACKING API CALL WILL BE CANCELLED (HTTP ERROR)
       EXAMPLE:
      <a> </a>   =>   <a target="_blank" click-tracking="[ 'Questionnaire', 'Continue', 'Question #' + vm.formId ]"> </a>
    */

    return {
      restrict: 'A',
      scope: true,
      link: function (scope, element, attrs) {
        function tracking() {
          //convert the attributes to object and get its properties
          var attribute = scope.$eval(attrs.clickTracking);

          if (attribute && Array.isArray(attribute) && attribute.length) {
            Tracking.trackAction('click', attribute);
          } else {
            Tracking.trackAction('click', []);
          }
        }

        element.on('click', tracking);
      }
    };
  }

  angular.module('pims').directive('clickTracking', clickTracking);
})();